import { createUseQueryHook } from './createUseQueryHook';

export const useGetPersonAvatarId = createUseQueryHook('get_person_avatar_id',
    { cacheTime: Infinity, refetchOnWindowFocus: false, staleTime: Infinity },
);
